import config from "../config"
const baseUrl = config.base_url + "z_farm_work_pesticide_fertilizer/"
export default {
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    v1_page: {
        url: baseUrl + "v1/page/{page}/{limit}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    save_v1: {
        url: baseUrl + "save_v1",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    selectOption: {
        url: baseUrl + "selectOption",
        type: "get",
    },
    v1_store_detail:{
        url: baseUrl + "v1_store_detail",
        type: "get",
    },
    downloadTemplate: {
        url: baseUrl + "download_template",
        type: "get",
    },
    uploadTemplate: {
        url: baseUrl + "import_v1",
        type: "post",
    }
}
